module.exports = __webpack_public_path__ + "media/images/icons/house-door-fill-942fe74a1d1343fc978002378f5ce73c.svg";